
const state = {
  user: null,
  loading: false,
};

const getters = {
  isSuperAdmin(state) {
    return state.user?.isSuperAdmin === true;
  },
  userRoles(state) {
    if (state.user?.roles) {
      return state.user.roles.split("|");
    }
    return [];
  },
  idToken(state) {
    return state.user?.idToken || null;
  },
  user(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.user !== null;
  },
};

const actions = {};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
